import { Alert, AlertButton, AlertOptions } from 'react-native';

export type ActionCallbackType = (value?: string) => void;

class AlertService {
  showAlert(
    title: string,
    message?: string,
    buttons?: AlertButton[],
    options?: AlertOptions,
  ) {
    Alert.alert(title, message, buttons, options);
  }

  showAlertWithTimeout(
    title: string,
    message: string,
    timeout: number,
  ) {
    setTimeout(() => this.showAlert(title, message), timeout);
  }

  showErrorAlert(errorMessage: string) {
    this.showAlert('Error', errorMessage, [
      { text: 'Ok', style: 'cancel' },
    ]);
  }

  showSomethingWentWrong() {
    this.showErrorAlert('Something went wrong');
  }

  showErrorAlertWithTimeout(errorMessage: string) {
    setTimeout(() => this.showErrorAlert(errorMessage), 700);
  }

  permissionDenied(
    title: string,
    onPress?: ActionCallbackType,
    message?: string,
  ) {
    this.showAlert(
      title,
      message,
      [
        {
          text: 'Cancel',
          style: 'cancel',
          onPress: () => true,
        },
        { text: 'Settings', onPress },
      ],
      { cancelable: false },
    );
  }

  permissionAsk(
    title: string,
    onPress: ActionCallbackType,
    message: string,
  ) {
    this.showAlert(
      title,
      message,
      [
        {
          text: 'Cancel',
          style: 'cancel',
          onPress: () => true,
        },
        { text: 'Settings', onPress },
      ],
      { cancelable: false },
    );
  }

  permissionError(title: string) {
    this.showAlert(title, 'Permission error');
  }

  iosRestrictedPermission(title: string) {
    this.showAlert(title, 'Restricted Permission');
  }
}

export default new AlertService();
